import React from 'react'
import styled from 'styled-components'
import TypographyAtom from '../typography/typography.atom'
import StackAtom from '../../to_layout/stack/stack.atom'
import ButtonAtom from '../../to_forms/button/button.atom'
import product_delivery_actionsStyles from './product_delivery_actions.styles'

interface ApDeliveryActionsProps {
  ap_delivery_details: string
}

const apAtomName = {ap_atom_name: 'productDeliveryActionsAtom'}

const StyleWrapper = styled.div`
  ${product_delivery_actionsStyles}
`

/* DEFAULT MODULE 
================================================= */
const ProductDeliveryActionsAtom = function (props: ApDeliveryActionsProps) {
  const {ap_delivery_details} = props

  return (
    <StyleWrapper {...apAtomName}>
      <TypographyAtom ahd_type="sData">{ap_delivery_details}</TypographyAtom>
      <StackAtom ap_type="row" className="delivery-actions">
        <div>
          <ButtonAtom ap_type="secondary">Add Instructions</ButtonAtom>
        </div>
        <div>
          <ButtonAtom ap_type="secondary">Change Date</ButtonAtom>
        </div>
      </StackAtom>
    </StyleWrapper>
  )
}
export default ProductDeliveryActionsAtom
